module.exports = __webpack_public_path__ + "img/reward_content_title_3.0ff6dcf0.png";